import React from 'react';
import PropTypes from 'prop-types';
import { getInstagramEmbedSrc } from 'helpers/portfolioEmbedUrls';

/**
 * Pixel box close to Instagram’s oEmbed iframe; tall enough to show full post + chrome (not 4:5).
 * Browse cards scale this down with CSS container queries (class `instagram-portfolio-embed`).
 */
const IG_EMBED_BASE_WIDTH = 326;
const IG_EMBED_BASE_HEIGHT = 580;

/** Capped width in normal flow; height follows IG aspect ratio. */
const INSTAGRAM_MAX_WIDTH_PX = 280;

/**
 * Instagram post / reel / tv embed via official iframe endpoint.
 * (React does not execute <script src=embed.js> from JSX, so blockquote+script never hydrated.)
 *
 * Wrapper is a span so output stays valid inside Markdown paragraph wrappers (no div-in-p).
 */
function BrowseInstagram({ postUrl }) {
  const embedSrc = getInstagramEmbedSrc(postUrl);

  if (!embedSrc) {
    return (
      <a href={postUrl} target="_blank" rel="nofollow noopener noreferrer">
        View on Instagram
      </a>
    );
  }

  return (
    <span
      style={{
        display: 'block',
        maxWidth: `min(100%, ${INSTAGRAM_MAX_WIDTH_PX}px)`,
        marginLeft: 'auto',
        marginRight: 'auto',
        overflow: 'hidden',
        lineHeight: 0,
      }}
    >
      <iframe
        className="instagram-portfolio-embed"
        src={embedSrc}
        title="Instagram post"
        width={IG_EMBED_BASE_WIDTH}
        height={IG_EMBED_BASE_HEIGHT}
        scrolling="no"
        style={{
          aspectRatio: `${IG_EMBED_BASE_WIDTH} / ${IG_EMBED_BASE_HEIGHT}`,
          width: '100%',
          maxWidth: '100%',
          height: 'auto',
          border: 'none',
          display: 'block',
          overflow: 'hidden',
        }}
        allow="encrypted-media; fullscreen; picture-in-picture"
        allowFullScreen
        loading="lazy"
        frameBorder="0"
      />
    </span>
  );
}

BrowseInstagram.propTypes = {
  postUrl: PropTypes.string,
};

export default BrowseInstagram;
